import {lazy, Suspense} from 'react';
import {DiagnosticReportId} from '@legit.health/ui';
import AppSkeleton from '@/components/AppSkeleton';
import useGetAnonymousDiagnosticReport from './hooks/useGetAnonymousDiagnosticReport';
const DiagnosticReport = lazy(() => import('@/components/DiagnosticReport'));

export default function DiagnosticReportPdf({
  diagnosticReportId,
  isPdf
}: {
  diagnosticReportId: DiagnosticReportId;
  isPdf?: boolean;
}) {
  const {
    data: {data: diagnosticReport}
  } = useGetAnonymousDiagnosticReport({
    diagnosticReportId
  });
  return (
    <Suspense fallback={<AppSkeleton />}>
      <DiagnosticReport diagnosticReport={diagnosticReport} isPdf={isPdf} />
    </Suspense>
  );
}
